(() => {
  const getDrawer = async () => {
    await customElements.whenDefined('cart-drawer');
    return document.querySelector('cart-drawer[data-section-id]');
  };

  const renderDrawer = async (sections, itemCount, openAfter = false) => {
    const drawer = await getDrawer();
    if (!drawer) return false;
    if (openAfter) drawer.open();
    if (!sections?.[drawer.dataset.sectionId]) return false;
    await drawer.renderCartContents({ itemCount, sections });
    return true;
  };

  const refreshDrawer = async (openAfter = false) => {
    const drawer = await getDrawer();
    if (!drawer) return;
    if (openAfter) drawer.open();
    const sectionId = drawer.dataset.sectionId;
    const root = window.Shopify?.routes?.root || '/';
    const [cartResponse, sectionsResponse] = await Promise.all([
      fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }),
      // Sans en-tête Accept JSON : sur une fiche produit, Shopify renverrait la fiche au lieu des sections.
      fetch(`${window.location.pathname}?sections=${encodeURIComponent(sectionId)}`)
    ]);
    const cart = await cartResponse.json();
    const sections = await sectionsResponse.json();
    await drawer.renderCartContents({ itemCount: cart.item_count, sections });
  };

  const openFromAddResponse = async (response) => {
    const drawer = await getDrawer();
    if (!drawer) return false;
    drawer.open();
    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    const rendered = await renderDrawer(response.sections, cart.item_count);
    if (!response.sections) await refreshDrawer(false);
    else if (!rendered) await refreshDrawer(false);
    return rendered;
  };

  const bindDrawer = (drawer) => {
    if (!drawer || drawer.dataset.moshiCartReady === 'true') return;
    drawer.dataset.moshiCartReady = 'true';

    drawer.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-moshi-quantity]');
      if (!quantityButton) return;
      const item = quantityButton.closest('cart-drawer-item');
      const input = item?.querySelector('[data-ref="quantity-selector-input"]');
      if (!input) return;
      const direction = quantityButton.dataset.moshiQuantity === 'plus' ? 1 : -1;
      input.value = Math.max(1, Number(input.value || 1) + direction);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    drawer.addEventListener('submit', async (event) => {
      const quickAdd = event.target.closest('.moshi-cart__quick-add');
      if (!quickAdd) return;
      event.preventDefault();
      const button = quickAdd.querySelector('button');
      button.disabled = true;
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(quickAdd)
        });
        await refreshDrawer(true);
      } finally {
        button.disabled = false;
      }
    });

  };

  const bindCartLinks = () => {
    document.querySelectorAll('a[href$="/cart"], a[href$="/cart/"]').forEach((link) => {
      if (link.dataset.moshiCartLink === 'true') return;
      link.dataset.moshiCartLink = 'true';
      link.addEventListener('click', (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        event.preventDefault();
        drawer.open();
      });
    });
  };

  // Les cadeaux à 0 € n'existent qu'avec un fond de teint payant : sinon on les retire du panier.
  let guarding = false;
  const guardGifts = async () => {
    if (guarding) return;
    guarding = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      const isGift = (item) => item.properties?._is_gift === 'true' || item.final_line_price === 0;
      const hasPaid = cart.items.some((item) => !isGift(item));
      const gifts = cart.items.filter(isGift);
      if (hasPaid || !gifts.length) return;
      const updates = {};
      gifts.forEach((item) => { updates[item.key] = 0; });
      await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      if (document.querySelector('cart-drawer[data-section-id]')) await refreshDrawer(false);
      if (window.location.pathname.endsWith('/cart')) window.location.reload();
    } catch (error) {
      // Le garde ne doit jamais bloquer le panier.
    } finally {
      guarding = false;
    }
  };
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const url = String(args[0]?.url || args[0] || '');
    if (/\/cart\/(change|update)(\.js)?/.test(url) && !guarding) window.setTimeout(guardGifts, 0);
    return response;
  };

  // Minuteur « commande réservée » : 10 minutes par visite, relancé à 10:00 une fois écoulé (comme Mushi).
  const RESERVE_SECONDS = 600;
  const tickReserve = () => {
    const timers = document.querySelectorAll('[data-moshi-timer]');
    if (!timers.length) return;
    let end = 0;
    try { end = Number(sessionStorage.getItem('moshiCartEnd')) || 0; } catch (error) { end = 0; }
    if (!end || end < Date.now()) {
      end = Date.now() + RESERVE_SECONDS * 1000;
      try { sessionStorage.setItem('moshiCartEnd', String(end)); } catch (error) { /* navigation privée */ }
    }
    const left = Math.max(0, Math.round((end - Date.now()) / 1000));
    const text = `${Math.floor(left / 60)}:${String(left % 60).padStart(2, '0')}`;
    timers.forEach((timer) => { timer.textContent = text; });
  };
  window.setInterval(tickReserve, 1000);

  window.MoshiCart = { refresh: refreshDrawer, openFromAddResponse, guardGifts };
  const init = () => { bindDrawer(document.querySelector('cart-drawer')); bindCartLinks(); guardGifts(); tickReserve(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
